import { Controller } from '@hotwired/stimulus'
import Popover from 'bootstrap/js/dist/popover'

export default class extends Controller {
  connect() {
    this.popover = new Popover(this.element)
  }

  disconnect() {
    this.popover.dispose()
  }
}
